import React from 'react';
import {
  findHighlightRanges,
  buildMatchPresentation,
  formatMatchHint,
  extractHighlightTerms,
  normalizeForMatch,
  fieldMatchesSearch,
} from './searchResultHighlightCore';

const highlightText = (text, terms, options = {}) => {
  if (!text) return text;
  if (!terms?.length) return text;

  const stringText = String(text);
  const ranges = findHighlightRanges(stringText, terms, options);
  if (ranges.length === 0) return stringText;

  const nodes = [];
  let cursor = 0;

  ranges.forEach((range, index) => {
    if (range.start > cursor) {
      nodes.push(stringText.slice(cursor, range.start));
    }
    nodes.push(
      <strong
        key={`hl-${index}-${range.start}`}
        className="font-bold text-gray-900 bg-yellow-50"
      >
        {stringText.slice(range.start, range.end)}
      </strong>
    );
    cursor = range.end;
  });

  if (cursor < stringText.length) {
    nodes.push(stringText.slice(cursor));
  }

  return nodes.length === 1 ? nodes[0] : nodes;
};

const highlightSlot = (text, slotTerms, slot, options = {}) => {
  const terms = slotTerms?.[slot];
  if (!text || !terms?.length) return text;
  return highlightText(text, terms, options);
};

export {
  extractHighlightTerms,
  normalizeForMatch,
  fieldMatchesSearch,
  findHighlightRanges,
  highlightText,
  highlightSlot,
  buildMatchPresentation,
  formatMatchHint,
};
